export default __webpack_public_path__ + "static/media/header_bg_league_uk.10de694d.jpg";